import { render } from "./ImpersonateCustomer.vue?vue&type=template&id=1bfab827&scoped=true"
import script from "./ImpersonateCustomer.vue?vue&type=script&lang=js"
export * from "./ImpersonateCustomer.vue?vue&type=script&lang=js"

import "./ImpersonateCustomer.vue?vue&type=style&index=0&id=1bfab827&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bfab827"]])

export default __exports__